import { Row, Col } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { SpecialBenefitItemType } from "src/types/plan";
import styled from "styled-components";
import { Title, Overline, Body } from "sunday-component";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const SpecialBenefitCardLabel = styled(Body).attrs({ level: 7 })`
  text-align: center;
  margin-top: 8px;
`;

const IconImg = styled.img`
  height: 60px;
  width: 60px;
`;

export type SpecialBenefitSectionProps = {
  specialBenefitItems: SpecialBenefitItemType[];
  insurerPlanCode: string;
};

export const SpecialBenefitSection = ({
  specialBenefitItems,
  insurerPlanCode,
}: SpecialBenefitSectionProps): JSX.Element => {
  const { t } = useTranslation("plan");
  const { locale } = useRouter();
  const { lg } = useBreakpoint();

  return (
    <Container>
      <Row justify="center">
        <Title level={lg ? 3 : 2}>{t("planCard.highlights")}</Title>
      </Row>
      <Row justify="center" gutter={[16, 16]}>
        {specialBenefitItems.length === 0 && (
          <Overline>{t("planCard.noSpecialBenefit")}</Overline>
        )}
        {specialBenefitItems.map((specialBenefit) => (
          <Col span={12} md={8} key={specialBenefit.code}>
            <Row justify="center">
              <IconImg
                key={specialBenefit.icon.code}
                data-cy={`plan-page.plan-card.${insurerPlanCode}.highlight.${specialBenefit.code}.img}`}
                src={specialBenefit.icon.url}
                alt={specialBenefit.icon.title}
              />
            </Row>
            <SpecialBenefitCardLabel
              data-cy={`plan-page.plan-card.${insurerPlanCode}.highlight.${specialBenefit.code}.label}`}
            >
              {specialBenefit.displayName[locale]}
            </SpecialBenefitCardLabel>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
